/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsShipSideView: {
  name: 'ship-side-view';
  data: string;
} = {
  name: 'ship-side-view',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M7 6a1 1 0 0 0-2 0v1H3a1 1 0 0 0-1 1v8a3 3 0 0 0 3 3h15.5a1 1 0 0 0 .923-1.385l-1.086-2.605 1.58-3.61A1 1 0 0 0 21 10h-6a1 1 0 0 0-.707.293l-.707.707H10V8a1 1 0 0 0-1-1H7V6ZM6 9H4v2h4V9H6Zm8.707 3.707.707-.707h4.057l-.875 2H17a1 1 0 1 0 0 2h1.583L19 17H5a1 1 0 0 1-1-1v-3h10a1 1 0 0 0 .707-.293Z" fill="currentColor"/></svg>`,
};
